@if (isModalVisible) {
  <div class="modal-overlay" (click)="closeModal()"></div>
}
@if (isModalVisible) {
  <div class="modal cart-modal">
    <div class="modal__header">
      <div class="modal__title">
        {{ 'global.cart' | translate }}
      </div>
      <button class="modal__close" (click)="closeModal()">
        <i class="mbi mbi-cross modal__close-icon"></i>
      </button>
    </div>
    <div
      class="modal__content cart-modal-content"
      [class.cart-empty]="!customerService.cart.length"
    >
      <cart [isCrossSellVisible]="isCrossSellVisible" (continueShopping)="closeModal()"></cart>
    </div>
  </div>
}
